export default __webpack_public_path__ + "static/media/15-100.3856b48f.jpg";